import React from 'react'

export default function AdminUsersFilters({
  activeFilter,
  setActiveFilter,
  stats,
  searchTerm,
  setSearchTerm,
}) {
  return (
    <>
      <div className="mb-4">
        <ul className="nav nav-tabs">
          <li className="nav-item">
            <button
              className={`nav-link ${activeFilter === 'all' ? 'active' : ''}`}
              onClick={() => setActiveFilter('all')}
              type="button"
            >
              All Users
              <span className="badge bg-secondary ms-2">{stats.total}</span>
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link ${activeFilter === 'never_registered' ? 'active' : ''}`}
              onClick={() => setActiveFilter('never_registered')}
              type="button"
            >
              Never Registered
              <span className="badge bg-warning ms-2">
                {stats.neverRegistered}
              </span>
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link ${activeFilter === 'not_in_active_league' ? 'active' : ''}`}
              onClick={() => setActiveFilter('not_in_active_league')}
              type="button"
            >
              Not in Active League
              <span className="badge bg-info ms-2">
                {stats.notInActiveLeague}
              </span>
            </button>
          </li>
        </ul>
      </div>

      <div className="mb-4">
        <div className="admin-users-search-box mb-3">
          <label htmlFor="user-search" className="visually-hidden">
            Search users
          </label>
          <i
            className="bi bi-search admin-users-search-icon"
            aria-hidden="true"
          ></i>
          <input
            id="user-search"
            type="text"
            className="form-control admin-users-search-input"
            placeholder="Search by name, email, user type, or ID..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className="admin-users-stats">
          <div className="admin-users-stats-item">
            <span>Total Users:</span>
            <span className="admin-users-stats-value">{stats.total}</span>
          </div>
          <div className="admin-users-stats-item">
            <span>Verified:</span>
            <span className="admin-users-stats-value">{stats.verified}</span>
          </div>
          <div className="admin-users-stats-item">
            <span>Admins:</span>
            <span className="admin-users-stats-value">{stats.admins}</span>
          </div>
          {searchTerm && (
            <div className="admin-users-stats-item">
              <span className="admin-users-filter-badge">
                <i className="bi bi-funnel-fill"></i>
                Showing {stats.showing} of {stats.total}
              </span>
            </div>
          )}
        </div>
      </div>
    </>
  )
}
